import React, { useEffect,useState } from "react";
import './../css/Home.css';
import { AlignJustify,Book,Calendar,ChevronRightIcon,LocateIcon,Settings, TicketCheck, Users } from 'lucide-react';
 
import axios from "./../../axios";
import AssignedClasses from "../../components/staff/AssignedClasses";
import StaffAttendanceHome from "../../components/staff/StaffAttendanceHome";
import StaffAlert from "./StaffAlert2";
import user_avtar from './../../images/user.jpg'
import { useNavigate } from "react-router-dom";
const StaffDashboard = ({setSideBar,setSettingDrawer,open_attendance, setOpen_attendance})=>{
    
    const [staff,setStaff] = useState(JSON.parse(localStorage.getItem('staff')));
    const school = JSON.parse(localStorage.getItem('school'));
   const getGreeting = () => {
    const now = new Date();
    const hour = now.getHours();
    if (hour >= 5 && hour < 12) {
      return "Good Morning!";
    } else if (hour >= 12 && hour < 17) {
      return "Good Afternoon!";
    } else {
      return "Good Evening!";
    }
  };
useEffect(() => {
   const fetchProfile = async () => {
    try {
 
      const response = await axios.get('teacher/profile', {
        params: {
          id: staff.id
        },
      });
 
      console.log(response.data);
         localStorage.setItem("staff", JSON.stringify(response.data));

    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  fetchProfile();
}, []);
const isInWebView = typeof window.ReactNativeWebView !== 'undefined';

useEffect(() => {
  const fcm_token = localStorage.getItem('fcm_token');
  const app_name = localStorage.getItem('app_name');
  const is_fcm_done = localStorage.getItem('is_fcm_done');

  const saveFCM = async () => {
    try {
      await axios.get('staff/save_fcm', {
        params: {
          id: staff.id,
          token: fcm_token,
          app_name: app_name
        },
      });
      localStorage.setItem('is_fcm_done', 1);
    } catch (error) {
      console.error('❌ FCM Save failed:', error);
    }
  };
 
  if ( !is_fcm_done) {
    saveFCM();
  }
}, []);
const navigate = useNavigate();

      return(<>

   <div className="top_bar">
 <svg className="home_bg" viewBox="0 0 500 100" preserveAspectRatio="none" style={{ transform: 'rotate(180deg)', display: 'block', width: '100%', height: '189px' }} > <defs> <linearGradient id="gradient" x1="0" y1="0" x2="1" y2="1"> <stop offset="0%" stopColor="#a1c4fd" /> <stop offset="100%" stopColor="#c2e9fb" /> </linearGradient> </defs> <path d="M0,40 C150,80 350,0 500,40 L500,100 L0,100 Z" fill="url(#gradient)" /> </svg>
 <div className="top_bar_items">
        <div className="top-menu-bar">
 <svg onClick={()=>setSideBar(true)} width="24" height="24" viewBox="0 0 24 24" fill="#333" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="3" width="8" height="8" rx="2"/>
  <rect x="14" y="3" width="8" height="8" rx="2"/>
  <rect x="3" y="14" width="8" height="8" rx="2"/>
  <rect x="14" y="14" width="8" height="8" rx="2"/>
</svg>

            <div style={{fontSize:'20px'}}>{school.school_name}</div>
            <Settings onClick={()=>setSettingDrawer(true)}/>
        </div>

        <div className="user-area">
            <div className="Avtar">
               <img src={staff.pic != '' && staff.pic!=null ?`https://new.proschoolerp.com/${staff.pic}`:user_avtar}/> 
            </div>
            <div className="user-info">
                <div className="plate">
                    {getGreeting()}<br></br>
                 {staff.name}
              
              
                <br/>
                {staff.post_name}
                </div>
            </div>
        </div>
 </div>
 </div> 

 {staff.uid==11 && (
    <div className="alert alert-warning" role="alert" style={{margin:'10px'}}>
    <button
      style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', background: '#dc4e4eff', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer', color: 'white', fontWeight: 'bold' }}
      onClick={() => window.location=('https://portal.mdnkalayat.com#open_in_browser')}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
        <polyline points="15 3 21 3 21 9"/>
        <line x1="10" y1="14" x2="21" y2="3"/>
      </svg>
      Go to MDN Digital
    </button>
  </div>
 )}
 <AssignedClasses/>
 <StaffAttendanceHome open={open_attendance}  setOpen={setOpen_attendance}/>
 {/* Quick Access Menues */}
<div style={{ display: 'flex',  gap: '16px', padding: '16px', margin: '16px 0' }}>
  <div 
  onClick={()=>navigate('/staff/diary')}
  style={{position:'relative',  width:'25%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px', cursor: 'pointer' }}>
<Book/>
    <label style={{ marginTop: '8px', fontSize: '14px', fontWeight: '500' }}>Diary</label>
    <span style={{
      position:'absolute',
      top:-5,right:-5, color:'red',textShadow:'1px 1px 7px'
    }}>AI</span>
  </div>
 <div   onClick={()=>navigate('/staff/attendance')}
 style={{ display: 'flex',width:'25%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px', cursor: 'pointer' }}>
<Calendar/>
    <label style={{ marginTop: '8px', fontSize: '14px', fontWeight: '500',textAlign:'center' }}>Student's Attendance</label>
  </div>
 
  <div
  onClick={()=>{
     window.location=`https://new.proschoolerp.com/app_emp/my_attendance?take_attendance&id=${staff.id}&pwd=${staff.password}&uid=${staff.uid}#browser_open`

  }}
  style={{ display: 'flex',width:'25%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px', cursor: 'pointer' }}>
<LocateIcon/>
    <label style={{ marginTop: '8px', fontSize: '14px', fontWeight: '500',textAlign:'center' }}>Geo Attendance</label>
  </div>
</div>
 <div onClick={()=>navigate("/staff/house-club-activity")} style={{ padding: '10px', margin: '10px' }}>
  <button style={{display:'flex',justifyContent:'space-between',alignItems:'center', width: '100%', padding: '12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}>
 <Users/>   House/Club Activities <ChevronRightIcon/>
  </button></div>
 <StaffAlert/>
       </>);
}
export default StaffDashboard;